module.exports = __webpack_public_path__ + "static/media/Pumpkin.2296c776.webp";